import styled from "styled-components";
import { color, layer, media, motion, radius } from "../../styles/theme";

export const ScrollUpButton = styled("button")<{ $visible: boolean }>`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: ${layer.header - 1};
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: ${color.bone};
  background: rgba(14, 14, 18, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid ${color.ash};
  border-radius: ${radius.md};

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transform: translateY(${({ $visible }) => ($visible ? "0" : "12px")});
  transition: opacity ${motion.base} ${motion.easeOut},
    transform ${motion.base} ${motion.ease},
    visibility ${motion.base} linear,
    border-color ${motion.fast} ${motion.easeOut},
    color ${motion.fast} ${motion.easeOut};

  &:hover {
    color: ${color.white};
    border-color: ${color.bloodBright};
    background: ${color.blood};
  }

  ${media.md} {
    right: 1rem;
    bottom: 1rem;
    width: 42px;
    height: 42px;
  }
`;
